import React from 'react';
import { NumberInput } from '../../uiold';
import {
  Box,
  Button,
  FormLabel,
  GridItem,
  Input,
  Select,
  SimpleGrid,
  Text,
} from '../../../core-ui';
import { PaymentSpringRequiredAchTokenParams } from '../../Settings/paymentspring/helpers';
import { PaymentFormProps } from './PaymentSpringPayment';

export function PaymentSpringAchForm(
  props: Omit<PaymentFormProps, 'handleFormChange' | 'formFields'> & {
    handleFormChange: (formFields: PaymentSpringRequiredAchTokenParams) => void;
    formFields: PaymentSpringRequiredAchTokenParams;
    achOnly: boolean;
  },
) {
  const {
    formattedPrice,
    onSubmit,
    formFields,
    handleFormChange,
    onAltPaymentClick,
    achOnly,
  } = props;

  const {
    bank_account_holder_first_name,
    bank_account_holder_last_name,
    bank_account_number,
    bank_routing_number,
    bank_account_type,
  } = formFields;

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onSubmit();
  };

  const bankAccountTypes = {
    checking: t('Checking'),
    savings: t('Savings'),
  };

  return (
    <Box as="form" onSubmit={handleSubmit} className="std-form embedded-form">
      <SimpleGrid columns={1} gap={2}>
        <GridItem>
          <Text>
            {t('To pay {formattedPrice} by ACH, use the following form.', {
              formattedPrice,
            })}
          </Text>
        </GridItem>
        {!achOnly && (
          <GridItem>
            <Button isFullWidth onClick={onAltPaymentClick}>
              {t('Pay with credit card instead')}
            </Button>
          </GridItem>
        )}
        <GridItem>
          <FormLabel>{t('Bank account number')}</FormLabel>
          <NumberInput
            onValueChange={(_valueAsNumber, valueAsString) => {
              const bankAccountNumber = valueAsString.replace(/\D/g, '');
              handleFormChange({
                ...formFields,
                bank_account_number: bankAccountNumber,
              });
            }}
            placeholder={t('Bank account number')}
            value={bank_account_number}
          />
        </GridItem>
        <GridItem>
          <FormLabel>{t('Bank routing number')}</FormLabel>
          <NumberInput
            onValueChange={(_valueAsNumber, valueAsString) => {
              const bankRoutingNumber = valueAsString.replace(/\D/g, '');
              handleFormChange({
                ...formFields,
                bank_routing_number: bankRoutingNumber,
              });
            }}
            placeholder={t('Bank routing number')}
            value={bank_routing_number}
          />
        </GridItem>
        <GridItem>
          <FormLabel>{t('First name')}</FormLabel>
          <Input
            onChange={(event) => {
              const cleanedValue = event.target.value.trim();
              handleFormChange({
                ...formFields,
                bank_account_holder_first_name: cleanedValue,
              });
            }}
            placeholder={t('First name')}
            value={bank_account_holder_first_name}
          />
        </GridItem>
        <GridItem>
          <FormLabel>{t('Last name')}</FormLabel>
          <Input
            onChange={(event) => {
              const cleanedValue = event.target.value.trim();
              handleFormChange({
                ...formFields,
                bank_account_holder_last_name: cleanedValue,
              });
            }}
            placeholder={t('Last name')}
            value={bank_account_holder_last_name}
          />
        </GridItem>
        <GridItem>
          <FormLabel>{t('Bank account type')}</FormLabel>
          <Select
            isFullWidth
            options={Object.keys(bankAccountTypes)}
            value={bank_account_type}
            onChange={(value) => {
              handleFormChange({
                ...formFields,
                bank_account_type: value,
              });
            }}
            getLabel={(key) => bankAccountTypes[key]}
          />
        </GridItem>
        <GridItem>
          <Button onClick={handleSubmit} variant="primary" width="100%">
            {t('Submit')}
          </Button>
        </GridItem>
      </SimpleGrid>
    </Box>
  );
}
